
export default {
  props: ["a"],
};
